import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { OrderData } from "../domain/checkout.entity";
import { PostCartDto, PostCartResp } from "@usecase/cart/cart.interface";
import { CreateOrderAffiliateDto, CreateOrderAffiliateResp } from "@usecase/checkout/create-order-btl/create-order-affiliate.interface";
import { CreateOrderPackageDto } from "@usecase/checkout/create-order-package/create-order-package.interface";
import { CreateOrderRoamingDto, CreateOrderRoamingResp } from "@usecase/checkout/create-order-roaming/create-order-roaming.type";
import { CheckoutDetailDto, CheckoutDetailResp } from "@usecase/checkout/checkout-detail/checkout-detail.type";

@Injectable({
    providedIn:'root'
})

export abstract class CheckoutRepository {
    abstract CreateOrderPackage(params: CreateOrderPackageDto): Observable<OrderData>;
    abstract CreateOrderAffiliate(params: CreateOrderAffiliateDto): Observable<CreateOrderAffiliateResp>;
    abstract PostCart(payload: PostCartDto):Observable<PostCartResp>;
    abstract CreateOrderRoaming(params: CreateOrderRoamingDto): Observable<CreateOrderRoamingResp>;
    abstract GetCheckoutDetail(params: CheckoutDetailDto): Observable<CheckoutDetailResp>;
}
